module.exports = __webpack_public_path__ + "media/images/categories/1-91ced4a4fc0c5e2c05cef05ba8bfc1ee.png";